(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/helpers/redirect-button.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/helpers/redirect-button.js');

'use strict';

const Button = svs.ui.Button;
const _ReactRouterDOM = ReactRouterDOM,
  useParams = _ReactRouterDOM.useParams;
const useRedirectTo = svs.components.marketplace.createGame.hooks.useRedirectTo;
const RedirectButton = _ref => {
  let className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Stäng' : _ref$label;
  const _useParams = useParams(),
    containerId = _useParams.containerId,
    activatedDrawId = _useParams.activatedDrawId,
    groupId = _useParams.groupId,
    teamPathName = _useParams.teamPathName;
  const _useRedirectTo = useRedirectTo(),
    redirectToGame = _useRedirectTo.redirectToGame,
    redirectToTeam = _useRedirectTo.redirectToTeam;
  return (
    React.createElement(Button, {
      block: true,
      className: className,
      onClick: () => {
        if (activatedDrawId) {
          redirectToGame({
            strategy: 'replace',
            activatedDrawId,
            containerId,
            groupId,
            teamPathName
          });
        } else {
          redirectToTeam({
            strategy: 'replace',
            groupId,
            teamPathName
          });
        }
      },
      size: 300,
      transparent: true,
      type: "button"
    }, label)
  );
};
setGlobal('svs.components.marketplace.createGame.helpers.RedirectButton', RedirectButton);

 })(window);